module.exports = import("https://cdn.jsdelivr.net/npm/flowise-embed/dist/web.js");;